import React from "react";
import { TasksController } from "./TasksController";
import { TasksViewModel } from "./TasksViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class TasksProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new TasksViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <TasksController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksProvider.js